import { render, staticRenderFns } from "./AnimatedTextarea.vue?vue&type=template&id=18524b1d&scoped=true&"
import script from "./AnimatedTextarea.vue?vue&type=script&lang=ts&"
export * from "./AnimatedTextarea.vue?vue&type=script&lang=ts&"
import style0 from "./AnimatedTextarea.vue?vue&type=style&index=0&id=18524b1d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18524b1d",
  null
  
)

export default component.exports